module.exports = __webpack_public_path__ + "../resources/img/ic_day_weather.4ae0f64c.svg";